import styled from "styled-components";

export const StyledPaypalLoader = styled.div`
    height: 60px;
    width: 100%;
    min-width: 280px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFC439;
    border-radius: 7px;

    img {
        height: 24px;
    }
` as any;
